module.exports = __webpack_public_path__ + "static/images/list-tag4.72c5c34.png";